
$(function() {

    let $body = $('.results');
    if (! $body[0]) return;

    $('.tag-radio').on('click', function(e) {
        var $box = $(e.target);
        if ($box.is(":checked")) {
            var group = "input:checkbox[name='" + $box.attr("name") + "']";
            $(group).prop("checked", false);
            $box.prop("checked", true);
        } else {
            $box.prop("checked", false);
        }
        $('#search-form').submit();
    });
});